export default __webpack_public_path__ + "static/media/logo-flux-color.a8f7f56e.png";